{
  "controls": {
    "back": "Zurück",
    "close": "Schließen",
    "last": "Fertig",
    "next": "Weiter",
    "skip": "Tour überspringen"
  },
  "dashboard": {
    "greeting": {
      "title": "Willkommen auf deinem Dashboard",
      "body": "Hier ist deine Startseite — ein schneller Überblick über Gelegenheiten, Snipes und deine wichtigsten Realms."
    },
    "kpi": {
      "title": "Aktuelle Gelegenheiten",
      "body": "Wie viele profitable Flips dir gerade über alle Tools hinweg zur Verfügung stehen."
    },
    "topOpportunities": {
      "title": "Top-Gelegenheiten",
      "body": "Eine Live-Vorschau der besten Flips. Wechsle die Tabs, um schnell verkäufliche Items oder Top-Käufe zu sehen."
    },
    "snipeAlerts": {
      "title": "Aktuelle Snipes",
      "body": "Snipe-Alarme aus dem letzten Aktualisierungszyklus. Klicke weiter, um neue Alarme einzurichten."
    },
    "realmStats": {
      "title": "Top-Realms",
      "body": "Deine stärksten Verkaufs-Realms, geordnet nach Bevölkerung, Auktionen oder Preisverhältnis."
    },
    "quickActions": {
      "title": "Schnellzugriff",
      "body": "Springe von hier direkt in jedes Tool."
    }
  },
  "flipping": {
    "dataFreshness": {
      "title": "Datenstatus",
      "body": "Zeigt, wie aktuell die Auktionsdaten sind. Die Seite aktualisiert sich automatisch, sobald neue Daten ankommen."
    },
    "filters": {
      "title": "Filterleiste",
      "body": "Schränke Ergebnisse nach Realm, Qualität, Profit, Verkaufsrate und mehr ein. Speichere deine Lieblingskombis als Presets."
    },
    "stats": {
      "title": "Investitionsübersicht",
      "body": "Gesamtwerte der sichtbaren Flips: nötige Investition, erwarteter Erlös und Gewinn nach Auktionshausgebühr."
    },
    "table": {
      "title": "Gelegenheiten",
      "body": "Jede Zeile ist ein Flip: auf einem Realm kaufen, auf einem anderen verkaufen. Klicke ein Item zum Kopieren oder Favorisieren."
    },
    "pagination": {
      "title": "Seitennavigation",
      "body": "Blättere durch die Ergebnisseiten und wähle, wie viele Items gleichzeitig angezeigt werden."
    }
  },
  "housing": {
    "dataFreshness": {
      "title": "Datenstatus",
      "body": "Zeigt, wie aktuell die Housing-Auktionsdaten sind und wann das nächste Update erwartet wird."
    },
    "filters": {
      "title": "Filterleiste",
      "body": "Schränke Housing-Flips nach Realm, Profit, Verkaufsrate und maximalem Buyout ein."
    },
    "stats": {
      "title": "Investitionsübersicht",
      "body": "Gesamtwerte der sichtbaren Housing-Flips, damit du dein Budget vor dem Kauf planen kannst."
    },
    "table": {
      "title": "Housing-Gelegenheiten",
      "body": "Jede Zeile ist ein Housing-Item, das auf einem Realm günstig zu haben ist und auf einem anderen mehr wert ist."
    },
    "pagination": {
      "title": "Seitennavigation",
      "body": "Blättere durch die Seiten und wähle, wie viele Ergebnisse angezeigt werden."
    }
  },
  "dropship": {
    "dataFreshness": {
      "title": "Datenstatus",
      "body": "Zeigt, wie aktuell die Dropship-Daten sind und wann die nächste Aktualisierung kommt."
    },
    "filters": {
      "title": "Filterleiste",
      "body": "Schränke Dropship-Gelegenheiten nach Realm, Qualität, Erweiterung und Profitabilität ein."
    },
    "stats": {
      "title": "Investitionsübersicht",
      "body": "Gesamtwerte der sichtbaren Dropship-Trades — nützlich für die Kapital- und Kapazitätsplanung."
    },
    "table": {
      "title": "Dropship-Gelegenheiten",
      "body": "Jede Zeile ist ein Item, das auf einem Realm gekauft und auf einem anderen mit Gewinn weiterverkauft werden kann."
    },
    "pagination": {
      "title": "Seitennavigation",
      "body": "Blättere durch die Seiten der Dropship-Ergebnisse."
    }
  },
  "inventory": {
    "realms": {
      "title": "Verkaufs-Realms",
      "body": "Wähle die Realms aus, gegen die dein Inventar analysiert werden soll."
    },
    "csv": {
      "title": "Inventar einfügen",
      "body": "Füge hier dein Inventar als CSV (Semikolon-getrennt) ein — das Tool sucht nach profitablen Cross-Realm-Trades."
    },
    "analyze": {
      "title": "Analysieren",
      "body": "Starte die Cross-Realm-Analyse für das Inventar, das du gerade eingefügt hast."
    },
    "results": {
      "title": "Flip-Empfehlungen",
      "body": "Jede Zeile ist ein Item aus deinem Inventar, das auf einem anderen Realm aktuell mehr wert ist."
    },
    "export": {
      "title": "Export",
      "body": "Lade die Analyse als CSV für eine Tabelle oder ein Addon herunter."
    }
  },
  "stats": {
    "table": {
      "title": "Realm-Statistiken",
      "body": "Vergleiche Auktionspreise, Angebote und Trends über alle Realms deiner Region."
    }
  },
  "tsm": {
    "filters": {
      "title": "Filter",
      "body": "Wähle aus, welche Items nach Kategorie, Erweiterung, Qualität und Profit aufgenommen werden."
    },
    "table": {
      "title": "Item-Liste",
      "body": "Items, die deinen Filtern entsprechen — direkt in eine TSM-Price-Source-Operation kopieren."
    },
    "pagination": {
      "title": "Seitennavigation",
      "body": "Blättere durch die Seiten und wähle, wie viele Items gleichzeitig angezeigt werden."
    }
  },
  "snipe": {
    "tabs": {
      "title": "Alarmkategorien",
      "body": "Wechsle zwischen Item-Snipes, Pet-Snipes, dem WoW-Token und Itemlevel-Regeln."
    },
    "add": {
      "title": "Neuen Alarm hinzufügen",
      "body": "Füge ein Item, Pet oder eine Regel zu deiner Watchlist hinzu — du wirst benachrichtigt, sobald es unter deinen Zielpreis fällt."
    },
    "list": {
      "title": "Aktive Alarme",
      "body": "Deine konfigurierten Alarme mit Zielpreisen und zugewiesenen Webhook-Kanälen."
    },
    "import": {
      "title": "Massenimport",
      "body": "Importiere eine ganze Liste auf einmal: Klicke auf Importieren, um eine Datei auszuwählen, oder füge eine kopierte Liste einfach irgendwo auf dieser Seite ein. Vor dem Speichern siehst du eine Vorschau des Imports."
    },
    "inlineEdit": {
      "title": "Preise direkt bearbeiten",
      "body": "Klicke auf einen Preis in der Tabelle, um ihn direkt zu bearbeiten — Enter speichert, Esc bricht ab. Gelöschte Alarme lassen sich mit Rückgängig wiederherstellen, und die Liste kann nach Name oder Preis sortiert werden."
    }
  },
  "tsmProfile": {
    "video": {
      "title": "Einrichtungsvideo",
      "body": "Schau dir dieses kurze Video für die vollständige TSM-Profil-Einrichtung an."
    },
    "min": {
      "title": "Mindestpreis",
      "body": "Kopiere diese Formel in deine TSM-Mindestpreis-Operation."
    },
    "max": {
      "title": "Höchstpreis",
      "body": "Kopiere diese Formel in deine TSM-Höchstpreis-Operation."
    },
    "normal": {
      "title": "Normalpreis",
      "body": "Kopiere diese Formel in deine TSM-Normalpreis-Operation."
    }
  },
  "settingsRealm": {
    "region": {
      "title": "Region",
      "body": "Wähle US oder EU — das steuert alle Realm-Listen in der App."
    },
    "buying": {
      "title": "Einkaufs-Realms",
      "body": "Die Realms, auf denen du günstig kaufst. Füge so viele hinzu, wie du bequem bereisen kannst."
    },
    "selling": {
      "title": "Verkaufs-Realms",
      "body": "Die Realms, auf denen du mit Gewinn verkaufst. Sie tauchen in jedem Tool als Ziel-Realms auf."
    },
    "accounts": {
      "title": "WoW-Accounts",
      "body": "Wenn du mehrere Accounts spielst, registriere sie hier und weise ihnen Realms zu."
    },
    "save": {
      "title": "Konfiguration speichern",
      "body": "Speichere — die restliche App nutzt diese Realms sofort."
    }
  },
  "settingsPersonal": {
    "preview": {
      "title": "Filter-Vorschau",
      "body": "Eine Live-Vorschau der Filter-UI, die du in den Flipping-Tools siehst."
    },
    "ranges": {
      "title": "Standardbereiche",
      "body": "Lege die Profit-, Verkaufsraten- und Preisbereiche fest, die in jedem Tool vorausgewählt sein sollen."
    },
    "dashboard": {
      "title": "Dashboard-Schwellen",
      "body": "Steuere Min- und Max-Buyout für die Gelegenheiten, die auf deinem Dashboard erscheinen."
    },
    "matching": {
      "title": "Item-Matching",
      "body": "Beschränke das Item-Stat-Matching auf bestimmte Erweiterungen für genauere Cross-Realm-Preise."
    },
    "save": {
      "title": "Standards speichern",
      "body": "Speichere diese Einstellungen als deine persönlichen Standards für alle Tools."
    }
  },
  "rowActions": {
    "title": "Zeilenaktionsmenü",
    "body": "Die erste Spalte vereint jetzt den Favoritenstern, die Auswahl-Checkbox und die Snipe-Alarm-Glocke. Über dieses Menü kannst du die aktuelle Seite oder alle Seiten aus- und abwählen, nur deine Favoriten behalten oder Favoriten, Snipe-Ziele und ausgewählte Zeilen oben anheften. Auch die Spalten-Einstellungen (Neuordnen per Drag, Ein-/Ausblenden) findest du hier."
  },
  "settingsDiscord": {
    "link": {
      "title": "Discord verknüpfen",
      "body": "Verknüpfe deinen Discord-Account, damit der Bot dir Alarme und Benachrichtigungen schicken kann."
    },
    "verification": {
      "title": "DMs verifizieren",
      "body": "Lass dir einen 6-stelligen Code schicken, um zu bestätigen, dass der Bot dich per DM erreichen kann."
    },
    "notifications": {
      "title": "Benachrichtigungseinstellungen",
      "body": "Aktiviere DM-Benachrichtigungen für Region-Updates und andere Ereignisse."
    },
    "webhooks": {
      "title": "Webhook-Kategorien",
      "body": "Lege Webhook-Kategorien an, um Snipe-Alarme an bestimmte Discord-Kanäle zu leiten."
    }
  },
  "classicDeals": {
    "controls": {
      "title": "Classic Deals",
      "body": "Pick your region and realms, then find same-realm undercut opportunities."
    },
    "table": {
      "title": "Deals",
      "body": "Each row is an item you can buy at the lowest price and relist just under the next-cheapest listing on the same realm."
    }
  },
  "filterMode": {
    "title": "Filtern oder neu berechnen",
    "body": "Lege fest, was bei einer Filteränderung passiert: „Filtern“ grenzt sofort die bereits geladenen Ergebnisse ein, „Neu berechnen“ holt frische Ergebnisse vom Server."
  }
}
